import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ConfirmationModal,
  Pagination,
  TailwindToaster,
  BrokerageServiceConversionModal,
} from "../../components";
import { MdExpandLess } from "react-icons/md";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";

import axios from "../../api/axios";

const Enquiry = () => {
  const state = useSelector((state) => state.UserReducer);
  const enquiryUrl = "/enquiry";
  const serviceOptionUrl = "/service";
  const subServiceOptionUrl = "/subservice";
  const executivesUrl = "/executives";

  const navigate = useNavigate();

  const [refreshData, setRefreshData] = React.useState(true);
  const [enquiryData, setEnquiryData] = React.useState([]);
  const [cookies, setCookies] = useCookies(["user"]);
  // const [updatedAssignee, setUpdatedAssignee] = React.useState(null);

  // const [enquiryServerData, setEnquiryServerData] = React.useState([]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(
    parseInt(cookies.enquiryCurrentPageIndex) || 0,
  );
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(
    parseInt(cookies.enquiryRecordsPerPage) || 25,
  );
  const getEnquiries = (queryOptions) => {
    try {
      axios
        .get(enquiryUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
            queryOptions,
            executiveId,
          },
        })
        .then((response) => {
          if (response?.data?.enquiries?.length >= 0) {
            setEnquiryData(response.data.enquiries);
            setExecutives(response.data.executives);
            // setEnquiryServerData(response.data.enquiries);
            if (response.data.enquiryCount?.length > 0) {
              setTotalRecords(response.data.enquiryCount[0].enquiryCnt);
              setTotalPages(
                Math.ceil(
                  response.data.enquiryCount[0].enquiryCnt / recordsPerPage,
                ),
              );
            } else {
              setTotalRecords(0);
              setTotalPages(0);
            }
          }
          setRefreshData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setRefreshData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };

  const [serviceOptionsData, setServiceOptionsData] = React.useState([]);
  const [subServiceOptionsData, setSubServiceOptionsData] = React.useState([]);
  const getServiceOptions = () => {
    try {
      axios
        .get(serviceOptionUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.services?.length > 0) {
            setServiceOptionsData(response.data.services);
            if (cookies.enquiryServiceTypeId) {
              // updateSubServiceOptions(serviceTypeId);
            }
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const updateSubServiceOptions = (serviceId) => {
    try {
      axios
        .get(subServiceOptionUrl + "/" + serviceId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subservice?.length >= 0) {
            setSubServiceOptionsData(response.data.subservice);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [leadFrom, setLeadFrom] = React.useState(
    cookies.enquiryLeadFrom ? cookies.enquiryLeadFrom : "",
  );
  const [leadTill, setLeadTill] = React.useState(
    cookies.enquiryLeadTill ? cookies.enquiryLeadTill : "",
  );
  const [serviceTypeId, setServiceTypeId] = React.useState(
    cookies.enquiryServiceTypeId
      ? cookies.enquiryServiceTypeId
      : ["user", "lead", "manager"].includes(state.user.aclGroup) &&
        state.user?.department?.name !== "CRM"
      ? state.user.service?._id
      : "",
  );
  const [subServiceTypeId, setSubServiceTypeId] = React.useState(
    cookies.enquirySubServiceTypeId ? cookies.enquirySubServiceTypeId : "",
  );
  const [searchText, setSearchText] = React.useState(
    cookies.enquirySearchText ? cookies.enquirySearchText : "",
  );
  const [channel, setChannel] = React.useState(
    cookies.enquiryChannel ? cookies.enquiryChannel : "",
  );

  React.useEffect(() => {
    setCookies("enquiryChannel", channel, {
      path: "/",
      maxAge: 300,
    });
  }, [channel]);
  const [searchStatus, setSearchStatus] = React.useState(
    cookies.enquiryOptionsSearchStatus
      ? cookies.enquiryOptionsSearchStatus
      : "",
  );
  const [executiveId, setExecutiveId] = React.useState(
    cookies.enquiryOptionsExecutiveId ? cookies.enquiryOptionsExecutiveId : "",
  );

  const [filterOn, setFilterOn] = React.useState(false);

  React.useEffect(() => {
    if (serviceTypeId !== "") updateSubServiceOptions(serviceTypeId);
    // console.log(state.user);
  }, [serviceTypeId]);

  const [enquiryEditId, setEnquiryEditId] = React.useState(null);
  const checkAndChangeEnquiryStatus = (
    enquiryID,
    enquiryStatus,
    remarks,
    assignee = null,
  ) => {
    setRefreshData(true);

    try {
      if (enquiryID === "Bulk") {
        axios
          .put(
            enquiryUrl + "/status/bulk/drop",
            JSON.stringify({
              enquiries: selectedIds,
            }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: state.user.token,
              },
            },
          )
          .then((response) => {
            if (response?.data?.status === "success") {
              toast.success(response?.data?.message);
              setSelectedIds([]);
              getEnquiries({
                status: searchStatus,
                leadFrom,
                leadTill,
                serviceTypeId,
                subServiceTypeId,
                channel,
                searchTerm: searchText.trim(),
              });
            } else {
              toast.error(response?.data?.message);
            }
            setRefreshData(false);
          })
          .catch((err) => {
            toast.error("Something went wrong");
            console.log(err);
            setRefreshData(false);
          });
      } else {
        axios
          .put(
            enquiryUrl + "/status/" + enquiryEditId,
            JSON.stringify({
              status: enquiryStatus,
              statusChangeRemarks: remarks,
              assignee,
            }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: state.user.token,
              },
            },
          )
          .then((response) => {
            if (response?.data?.status === "success") {
              toast.success(response?.data?.message);
              setEnquiryEditId(null);
              getEnquiries({
                status: searchStatus,
                leadFrom,
                leadTill,
                serviceTypeId,
                subServiceTypeId,
                channel,
                searchTerm: searchText.trim(),
              });
            } else {
              toast.error(response?.data?.message);
            }
            setRefreshData(false);
          })
          .catch((err) => {
            toast.error("Something went wrong");
            console.log(err);
            setRefreshData(false);
          });
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };

  const [deletePopupId, setDeletePopup] = React.useState(null);
  const deleteEnquiry = (enquiryId) => {
    setRefreshData(true);
    try {
      axios
        .delete(enquiryUrl + "/" + enquiryId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            getEnquiries({
              leadFrom,
              leadTill,
              status: searchStatus,
              serviceTypeId,
              subServiceTypeId,
              channel,
              searchTerm: searchText.trim(),
            });
          } else toast.error(response?.data?.message);
          setRefreshData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setRefreshData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };
  const confirmDelete = (enquiryId) => {
    setDeletePopup(enquiryId);
  };
  const closeConfirmation = () => {
    setDeletePopup(null);
    setUpdateStatusPopup(null);
    setEnquiryEditId(null);
  };
  const deleteConfirmation = (canDelete) => {
    if (canDelete) deleteEnquiry(deletePopupId);
    closeConfirmation();
  };

  const [updateStatusItem, setUpdateStatusPopup] = React.useState(null);
  const changeStatusToInProcessForBrokerage = (item, targetValue) => {
    console.log(item);
    setUpdateStatusPopup(item);
  };
  const statusChangeConfirmation = (proceedFlag, remarks, assignee) => {
    if (proceedFlag)
      checkAndChangeEnquiryStatus(
        updateStatusItem,
        "IN-PROCESS",
        remarks,
        assignee,
      );
    closeConfirmation();
  };

  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "HOLD":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            HOLD
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN-PROCESS
          </span>
        );
      case "DROPPED":
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            DROPPED
          </span>
        );
    }
  };

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
    setCookies("enquiryCurrentPageIndex", targetPageIndex, {
      path: "/",
      maxAge: 300,
    });
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
    setCookies("enquiryRecordsPerPage", targetRecordsPerPage, {
      path: "/",
      maxAge: 300,
    });
  };

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [selectAll, setSelectAll] = React.useState(false);
  const [selectedIds, setSelectedIds] = React.useState([]);

  React.useEffect(() => {
    if (selectAll === false && enquiryData.length === selectedIds.length)
      setSelectedIds([]);
    else if (selectAll === true) {
      const newArray = [];
      enquiryData.map((item) => {
        newArray.push(item?._id);
      });
      setSelectedIds(newArray);
    }
  }, [selectAll]);

  React.useEffect(() => {
    if (enquiryData.length !== selectedIds.length) setSelectAll(false);
    // console.log(selectedIds);
  }, [selectedIds]);

  const [executives, setExecutives] = React.useState([]);
  // const getExecutives = () => {
  //   try {
  //     axios
  //       .get(executivesUrl, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: state.user.token,
  //         },
  //         params: {
  //           service: serviceTypeId,
  //           from: "enquiries",
  //         },
  //       })
  //       .then((response) => {
  //         if (response?.data?.users?.length > 0) {
  //           setExecutives(response.data.users);
  //         }
  //       })
  //       .catch((err) => {
  //         toast.error("Something went wrong");
  //         console.log(err);
  //       });
  //   } catch (err) {
  //     toast.error("Something went wrong");
  //     console.log(err);
  //   }
  // };

  React.useEffect(() => {
    setRefreshData(true);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    getServiceOptions();
    setPageTitle("Enquiry - L&L ERP");
    if (
      serviceTypeId !== "" ||
      ["admin", "super-admin"].includes(state.user.aclGroup) ||
      state.user.department.name === "CRM"
    ) {
      // getExecutives();
    }

    const delayDebounceFn = setTimeout(() => {
      getEnquiries({
        leadFrom,
        leadTill,
        status: searchStatus,
        serviceTypeId,
        subServiceTypeId,
        channel,
        searchTerm: searchText.trim(),
      });
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    recordsPerPage,
    currentPageIndex,
    leadFrom,
    leadTill,
    searchStatus,
    serviceTypeId,
    subServiceTypeId,
    searchText,
    executiveId,
    channel,
  ]);

  return (
    <>
      {deletePopupId && (
        <ConfirmationModal
          actionName={"Delete"}
          deleteConfirmation={deleteConfirmation}
          moduleName={"Delete Enquiry"}
          itemName={"Enquiry Record"}
          closeConfirmation={closeConfirmation}
        />
      )}
      {updateStatusItem && (
        <BrokerageServiceConversionModal
          statusChangeConfirmation={statusChangeConfirmation}
          closeConfirmation={closeConfirmation}
          enquiryItem={updateStatusItem}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex justify-between min-w-0 px-5 lg:px-0'>
                <h2 className='sm:mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl '>
                  Enquiry
                </h2>
                <div className='show sm:hidden'>
                  <Link to='/enquiry/create'>
                    <button
                      type='button'
                      className='inline-flex  items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                      Create
                    </button>
                  </Link>
                </div>
              </div>
              <div className='flex mt-3 sm:ml-4 ml-5 sm:mr-0 mr-5 w-full'>
                <div className='justify-end space-x-2 w-full hidden sm:flex'>
                  <div className='flex space-x-2'>
                    <div className='pt-1'>
                      <label
                        htmlFor='leadFrom'
                        className='block text-xs font-medium text-gray-700'>
                        Lead From
                      </label>
                      <input
                        type='date'
                        name='leadFrom'
                        id='leadFrom'
                        defaultValue={leadFrom}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies("enquiryLeadFrom", event.target.value, {
                            path: "/",
                            maxAge: 300,
                          });
                          setLeadFrom(event.target.value);
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                    <div className='pt-1'>
                      <label
                        htmlFor='leadTill'
                        className='block text-xs font-medium text-gray-700'>
                        Lead Till
                      </label>
                      <input
                        type='date'
                        name='leadTill'
                        id='leadTill'
                        defaultValue={leadTill}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies("enquiryLeadTill", event.target.value, {
                            path: "/",
                            maxAge: 300,
                          });
                          setLeadTill(event.target.value);
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                    {(["super-admin", "admin"].includes(state.user?.aclGroup) ||
                      ["CRM"].includes(state.user?.department?.name)) && (
                      <div className='w-40 pt-1'>
                        <label
                          htmlFor='serviceTypeId'
                          className={`block text-xs font-medium text-gray-700`}>
                          Service
                        </label>
                        <select
                          id='serviceTypeId'
                          name='serviceTypeId'
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                          value={serviceTypeId}
                          onChange={(event) => {
                            setCurrentPageIndex(0);
                            setCookies(
                              "enquiryServiceTypeId",
                              event.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                            setServiceTypeId(event.target.value);
                            // updateSubServiceOptions(event.target.value);
                          }}>
                          <option key='0' value=''>
                            Select
                          </option>
                          {serviceOptionsData.length > 0 ? (
                            serviceOptionsData.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.name}
                              </option>
                            ))
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                    )}
                    <div className='w-40 pt-1'>
                      <label
                        htmlFor='subServiceTypeId'
                        className={`block text-xs font-medium text-gray-700`}>
                        Sub Service
                      </label>
                      <select
                        id='subServiceTypeId'
                        name='subServiceTypeId'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={subServiceTypeId}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "enquirySubServiceTypeId",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setSubServiceTypeId(event.target.value);
                        }}>
                        <option key='0' value=''>
                          Select
                        </option>
                        {subServiceOptionsData.length > 0 ? (
                          subServiceOptionsData.map((item) => (
                            <option key={item?._id} value={item?._id}>
                              {item?.name}
                            </option>
                          ))
                        ) : (
                          <option key='1' value=''>
                            Loading...
                          </option>
                        )}
                      </select>
                    </div>
                    <div className='w-36 pt-1'>
                      <label
                        htmlFor='subServiceTypeId'
                        className={`block text-xs font-medium text-gray-700`}>
                        Status
                      </label>
                      <select
                        id='enquiryStatus'
                        name='enquiryStatus'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={searchStatus}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "enquiryOptionsSearchStatus",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setSearchStatus(event.target.value);
                        }}>
                        <option key='0' value=''>
                          Active
                        </option>
                        <option>All</option>
                        <option>NEW</option>
                        <option>ASSIGNED</option>
                        <option value='IN-PROCESS'>IN-PROCESS</option>
                        <option>HOLD</option>
                        <option>DROPPED</option>
                      </select>
                    </div>
                    <div className='pt-1'>
                      <label
                        htmlFor='channel'
                        className={`block text-xs font-medium text-gray-700`}>
                        Channel
                      </label>
                      <select
                        id='channel'
                        name='channel'
                        value={channel}
                        className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs rounded-sm`}
                        onChange={(event) => {
                          setChannel(event.target.value);
                        }}>
                        <option value=''>Select</option>
                        <option value='99 acres'>99 acres</option>
                        <option value='Agent'>Agent</option>
                        <option value='BNI'>BNI</option>
                        <option value='Common Floor'>Common Floor</option>
                        <option value='Email'>Email</option>
                        <option value='Facebook'>Facebook</option>
                        <option value='Fieldwork'>Fieldwork</option>
                        <option value='Just Dial'>Just Dial</option>
                        <option value='Knowlarity'>Knowlarity</option>
                        <option value='Magic Bricks'>Magic Bricks</option>
                        <option value='Net Search'>Net Search</option>
                        <option value='Newspaper Ad'>Newspaper Ad</option>
                        <option value='Old Client'>Old Client</option>
                        <option value='Online Marketing'>
                          Online Marketing
                        </option>
                        <option value='On Site Board'>On Site Board</option>
                        <option value='Reference'>Reference</option>
                        <option value='Walk-in'>Walk-in</option>
                        <option value='Website'>Website</option>
                        <option>Others</option>
                      </select>
                    </div>
                    {(["admin", "super-admin", "manager", "lead"].includes(
                      state.user.aclGroup,
                    ) ||
                      state.user.department.name === "CRM") && (
                      <div className='w-36 mt-1'>
                        <label
                          htmlFor='executive'
                          className={`block text-xs font-medium text-gray-700`}>
                          Executive
                        </label>
                        <select
                          id='executive'
                          name='executive'
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                          value={executiveId}
                          onChange={(event) => {
                            setCurrentPageIndex(0);
                            setExecutiveId(event.target.value);
                            setCookies(
                              "enquiryOptionsExecutiveId",
                              event.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}>
                          <option key='0' value=''>
                            All
                          </option>
                          {executives.length > 0 ? (
                            executives.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.fullname
                                  ? item?.fullname
                                  : item?.firstname}
                              </option>
                            ))
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                    )}
                    <div className='pt-5'>
                      <input
                        type='text'
                        name='search'
                        id='search'
                        defaultValue={searchText}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies("enquirySearchText", event.target.value, {
                            path: "/",
                            maxAge: 300,
                          });
                          setSearchText(event.target.value.toLowerCase());
                        }}
                        placeholder='Search'
                        maxLength='20'
                        className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                      />
                    </div>
                  </div>
                  <div className='pt-5'>
                    <span className=''>
                      <Link to='/enquiry/create'>
                        <button
                          type='button'
                          className='inline-flex items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                          Create
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>
                <div className='flex w-11/12 sm:hidden'>
                  <div className='flex-col w-full bg-gray-100 rounded-sm px-2 py-2 pb-2.5'>
                    <div
                      className='flex justify-between'
                      onClick={(event) => {
                        setFilterOn(!filterOn);
                      }}>
                      <span className='font-semibold text-md'>Filters</span>
                      <MdExpandLess
                        className={`text-xl ${
                          filterOn ? "rotate-0" : "rotate-180"
                        } duration-300`}
                      />
                    </div>
                    <div
                      className={`flex flex-col ${
                        filterOn ? "show" : "hidden"
                      } duration-300 transition ease-in-out`}>
                      <div className='flex space-x-3 '>
                        <div className='pt-1 w-6/12'>
                          <label
                            htmlFor='leadFrom'
                            className='block text-xs font-medium text-gray-700'>
                            Lead From
                          </label>
                          <input
                            type='date'
                            name='leadFrom'
                            id='leadFrom'
                            defaultValue={leadFrom}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setCookies(
                                "enquiryLeadFrom",
                                event.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              setLeadFrom(event.target.value);
                            }}
                            className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                          />
                        </div>
                        <div className='pt-1 w-6/12'>
                          <label
                            htmlFor='leadTill'
                            className='block text-xs font-medium text-gray-700'>
                            Lead Till
                          </label>
                          <input
                            type='date'
                            name='leadTill'
                            id='leadTill'
                            defaultValue={leadTill}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setCookies(
                                "enquiryLeadTill",
                                event.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              setLeadTill(event.target.value);
                            }}
                            className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                          />
                        </div>
                      </div>
                      <div className='flex space-x-3'>
                        <div
                          className={`pt-1 w-6/12 ${
                            ["super-admin", "admin"].includes(
                              state.user?.aclGroup,
                            )
                              ? "opacity-100"
                              : "opacity-30 pointer-events-none"
                          }`}>
                          <label
                            htmlFor='serviceTypeId'
                            className={`block text-xs font-medium text-gray-700`}>
                            Service
                          </label>
                          <select
                            id='serviceTypeId'
                            name='serviceTypeId'
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                            value={serviceTypeId}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setServiceTypeId(event.target.value);
                              // updateSubServiceOptions(event.target.value);
                            }}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {serviceOptionsData.length > 0 ? (
                              serviceOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                        <div className='w-6/12 pt-1'>
                          <label
                            htmlFor='subServiceTypeId'
                            className={`block text-xs font-medium text-gray-700`}>
                            Sub Service
                          </label>
                          <select
                            id='subServiceTypeId'
                            name='subServiceTypeId'
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                            value={subServiceTypeId}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setCookies(
                                "enquiryServiceTypeId",
                                event.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              setSubServiceTypeId(event.target.value);
                            }}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {subServiceOptionsData.length > 0 ? (
                              subServiceOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className='grid grid-cols-2 gap-x-3'>
                        <div className='pt-1 w-full'>
                          <label
                            htmlFor='channel'
                            className={`block text-xs font-medium text-gray-700`}>
                            Channel
                          </label>
                          <select
                            id='channel'
                            name='channel'
                            value={channel}
                            className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs rounded-sm`}
                            onChange={(event) => {
                              setChannel(event.target.value);
                            }}>
                            <option value=''>Select</option>
                            <option value='99 acres'>99 acres</option>
                            <option value='Agent'>Agent</option>
                            <option value='BNI'>BNI</option>
                            <option value='Common Floor'>Common Floor</option>
                            <option value='Email'>Email</option>
                            <option value='Facebook'>Facebook</option>
                            <option value='Fieldwork'>Fieldwork</option>
                            <option value='Just Dial'>Just Dial</option>
                            <option value='Knowlarity'>Knowlarity</option>
                            <option value='Magic Bricks'>Magic Bricks</option>
                            <option value='Net Search'>Net Search</option>
                            <option value='Newspaper Ad'>Newspaper Ad</option>
                            <option value='Old Client'>Old Client</option>
                            <option value='Online Marketing'>
                              Online Marketing
                            </option>
                            <option value='On Site Board'>On Site Board</option>
                            <option value='Reference'>Reference</option>
                            <option value='Walk-in'>Walk-in</option>
                            <option value='Website'>Website</option>
                            <option>Others</option>
                          </select>
                        </div>
                        <div className='w-full'>
                          {["admin", "super-admin", "manager", "lead"].includes(
                            state.user.aclGroup,
                          ) && (
                            <div className='pt-1 w-full'>
                              <div className='w-full'>
                                <label
                                  htmlFor='executive'
                                  className={`block text-xs font-medium text-gray-700`}>
                                  Executive
                                </label>
                                <select
                                  id='executive'
                                  name='executive'
                                  className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                  value={executiveId}
                                  onChange={(event) => {
                                    setCurrentPageIndex(0);
                                    setExecutiveId(event.target.value);
                                    setCookies(
                                      "enquiryOptionsExecutiveId",
                                      event.target.value,
                                      {
                                        path: "/",
                                        maxAge: 300,
                                      },
                                    );
                                  }}>
                                  <option key='0' value=''>
                                    All
                                  </option>
                                  {executives.length > 0 ? (
                                    executives.map((item) => (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.fullname
                                          ? item?.fullname
                                          : item?.firstname}
                                      </option>
                                    ))
                                  ) : (
                                    <option key='1' value=''>
                                      Loading...
                                    </option>
                                  )}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='pt-1 w-full col-span-2'>
                          <label
                            htmlFor='subServiceTypeId'
                            className={`block text-xs font-medium text-gray-700`}>
                            Search
                          </label>
                          <input
                            type='text'
                            name='search1'
                            id='search1'
                            defaultValue={searchText}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setCookies(
                                "enquirySearchText",
                                event.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              setSearchText(event.target.value.toLowerCase());
                            }}
                            placeholder=''
                            maxLength='20'
                            className='focus:ring-yellow-2 text-xs focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                          />
                        </div>
                        {/* <div className='pt-7 w-4/12 flex justify-end'>
                        <span className=''>
                          <Link to='/enquiry/create'>
                            <button
                              type='button'
                              className='inline-flex items-center px-4 py-1.5 border border-gray-300 rounded-sm shadow-sm text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                              Create
                            </button>
                          </Link>
                        </span>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='px-4 py-3 sm:px-0'>
              <TailwindToaster />
              <div className='hidden md:block shadow-lg'>
                <div
                  className={`w-full transition ${
                    selectedIds.length > 0 ? "visible h-max" : "invisible h-0"
                  } duration-500 flex justify-start`}>
                  <div className='py-3 px-4 flex flex-row gap-x-2 border-0 rounded-sm bg-yellow-100'>
                    <div
                      htmlFor='subServiceTypeId'
                      className={`pt-1.5 block text-sm whitespace-nowrap font-medium text-gray-700`}>
                      Bulk Status Change
                    </div>
                    <button
                      type='button'
                      onClick={(event) => {
                        checkAndChangeEnquiryStatus("Bulk", "DROPPED", "");
                      }}
                      className='inline-flex items-center duration-300 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-yellow-dark  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                      Drop Enquiries
                    </button>
                  </div>
                </div>
                <table className='z-30 table-auto w-full shadow rounded-sm border-1 border-gray-dark'>
                  <thead className='bg-gray-50 border-b-2 border-yellow'>
                    <tr>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        <input
                          className='h-4 w-4 text-yellow focus:ring-0 focus:ring-transparent'
                          type='checkbox'
                          onChange={(event) => {
                            event.preventDefault();
                            setSelectAll(event.target.checked);
                          }}
                          checked={selectAll}
                        />
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Enquiry&nbsp;ID
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Date
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Customer&nbsp;Name
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Mobile&nbsp;#
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Channel
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Service Details
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Status
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Entered By
                      </th>
                      {state.user.department?.name === "CRM" ||
                        (state.user?.aclGroup === "super-admin" && (
                          <th
                            colSpan='2'
                            className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-left'></th>
                        ))}
                    </tr>
                  </thead>
                  {!refreshData ? (
                    <tbody>
                      {enquiryData?.length > 0 ? (
                        enquiryData.map((item, index) => (
                          <tr
                            key={item?._id}
                            className='hover:shadow-lg duration-300 cursor-default'>
                            <td className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                              {selectedIds && (
                                <input
                                  className='h-4 w-4 text-yellow focus:ring-0 focus:ring-transparent'
                                  type='checkbox'
                                  onChange={(event) => {
                                    // event.preventDefault();
                                    if (event.target.checked) {
                                      setSelectedIds([
                                        ...selectedIds,
                                        item?._id,
                                      ]);
                                    } else {
                                      const newArray = selectedIds.filter(
                                        (item1) => item1 != item?._id,
                                      );
                                      setSelectedIds(newArray);
                                    }
                                  }}
                                  checked={selectedIds.includes(item?._id)}
                                />
                              )}
                            </td>
                            <td
                              className='px-3 py-3 font-semibold text-sm tracking-wide text-center'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              #{item?.enquiryID}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.leadEnteredDate?.toString().slice(0, 10)}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-left'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.addressBookId?.prefix &&
                              item?.addressBookId?.firstName
                                ? item?.addressBookId?.prefix +
                                  ". " +
                                  item?.addressBookId?.firstName +
                                  " " +
                                  (item?.addressBookId?.lastName
                                    ? item?.addressBookId?.lastName
                                    : "")
                                : ""}
                            </td>
                            <td className='px-2 py-3 font-normal text-xs tracking-wide text-center'>
                              {item?.addressBookId
                                ? item?.addressBookId?.crm?._id ===
                                  "636751da314cd73283ec3671"
                                  ? "+" +
                                    item?.addressBookId?.countryCode +
                                    " " +
                                    item?.addressBookId?.phoneNumber.slice(
                                      0,
                                      2,
                                    ) +
                                    "XXX XX" +
                                    item?.addressBookId?.phoneNumber.slice(
                                      7,
                                      10,
                                    )
                                  : "+" +
                                    item?.addressBookId?.countryCode +
                                    " " +
                                    item?.addressBookId?.phoneNumber
                                : "--"}
                            </td>
                            <td
                              className='px-2 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.channel}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.serviceTypeId
                                ? item?.serviceTypeId?.name
                                : "--"}{" "}
                              &gt;{" "}
                              {item?.subServiceTypeId
                                ? item?.subServiceTypeId?.name
                                : "--"}
                            </td>
                            <td className='px-3 py-3 font-semibold text-xs tracking-wide text-center'>
                              {enquiryEditId === item?._id ? (
                                <select
                                  onBlur={(event) => {
                                    if (
                                      !(
                                        (event.target.value === "IN-PROCESS")
                                        //  &&
                                        // item?.serviceTypeId?._id ===
                                        //   "632e9b76b10c8102926ba9be"
                                      )
                                    )
                                      setEnquiryEditId(null);
                                  }}
                                  onChange={(event) => {
                                    event.preventDefault();
                                    if (
                                      event.target.value === "IN-PROCESS"
                                      //  &&
                                      // item?.serviceTypeId?._id ===
                                      //   "632e9b76b10c8102926ba9be"
                                    ) {
                                      changeStatusToInProcessForBrokerage(
                                        item,
                                        event.target.value,
                                      );
                                    } else {
                                      checkAndChangeEnquiryStatus(
                                        item?._id,
                                        event.target.value,
                                        "",
                                      );
                                    }
                                  }}
                                  defaultValue={item?.status?.toUpperCase()}
                                  className='mt-1 block w-full py-1 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                  <option>NEW</option>
                                  {/* <option>ASSIGNED</option> */}
                                  <option value='IN-PROCESS'>IN-PROCESS</option>
                                  <option>DROPPED</option>
                                </select>
                              ) : (
                                <div className='grid grid-cols-4'>
                                  {(state.user.department?.name === "CRM" ||
                                    state.user?.aclGroup === "super-admin") &&
                                  ["NEW", "ASSIGNED", "HOLD"].includes(
                                    item?.status,
                                  ) ? (
                                    <div className='col-span-3 overflow-x-auto peer'>
                                      <p className='peer'>
                                        {renderStatus(item?.status)}
                                      </p>
                                    </div>
                                  ) : (
                                    <div className='col-span-3 overflow-x-auto overflow-y-hidden peer'>
                                      <p className='peer'>
                                        {renderStatus(item?.status)}
                                      </p>
                                    </div>
                                  )}
                                  {(state.user.department?.name === "CRM" ||
                                    state.user?.aclGroup === "super-admin") &&
                                  ["NEW", "ASSIGNED", "HOLD"].includes(
                                    item?.status,
                                  ) ? (
                                    <div
                                      className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                      onClick={(event) => {
                                        setEnquiryEditId(item?._id);
                                      }}>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='h-6 w-6'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'>
                                        <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className='ml-0 opacity-0 '></div>
                                  )}
                                </div>
                              )}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(event) => {
                                navigate(enquiryUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.createdBy?.fullname
                                ? item?.createdBy?.fullname
                                : item?.createdBy?.firstname}
                              {item?.melaLead && "(Mela Lead)"}
                            </td>
                            {(state.user.department?.name === "CRM" ||
                              state.user?.aclGroup === "super-admin" ||
                              state.user._id === item?.createdBy) &&
                              ["NEW", "ASSIGNED", "HOLD"].includes(
                                item?.status,
                              ) && (
                                <td
                                  onClick={(event) => {
                                    navigate(`/enquiry/edit/${item?._id}`, {
                                      replace: false,
                                    });
                                  }}
                                  className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow-2 text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                            {(state.user.department?.name === "CRM" ||
                              state.user?.aclGroup === "super-admin" ||
                              state.user._id === item?.createdBy) &&
                              item?.status.toLowerCase() === "new" && (
                                <td
                                  onClick={() => {
                                    confirmDelete(item?._id);
                                  }}
                                  className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                  Delete
                                </td>
                              )}
                          </tr>
                        ))
                      ) : (
                        <tr className='hover:shadow-lg duration-300'>
                          <td
                            className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                            colSpan='5'>
                            No data available to display
                          </td>
                        </tr>
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
                {enquiryData.length > 0 && (
                  <Pagination
                    pages={totalPages}
                    currentPage={currentPageIndex}
                    recordsPerPage={recordsPerPage}
                    changePageCallback={changePageCallback}
                    totalRecords={totalRecords}
                    changeDisplayRecordCountCallback={
                      changeDisplayRecordCountCallback
                    }
                  />
                )}
              </div>
              <div className='block md:hidden'>
                {!refreshData ? (
                  <div className='grid grid-cols-1 gap-4'>
                    {enquiryData.length > 0 ? (
                      <div>
                        {enquiryData.map((item) => (
                          <div
                            key={item?._id}
                            className='px-1 py-1 pb-2 shadow border-b-2 border-gray-100 hover:bg-gray-100 z-0'>
                            <div className='grid grid-cols-6'>
                              <div
                                className='col-span-4'
                                onClick={(event) => {
                                  navigate(enquiryUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                                  #{item?.enquiryID} |{" "}
                                  {item?.leadEnteredDate.slice(0, 10)}
                                </h4>
                              </div>
                              <div
                                className='col-span-2'
                                // onClick={(event) => {
                                //   navigate(enquiryUrl + "/" + item?._id, {
                                //     replace: false,
                                //   });
                                // }}
                              >
                                {enquiryEditId === item?._id ? (
                                  <select
                                    onChange={(event) => {
                                      event.preventDefault();
                                      if (
                                        event.target.value === "IN-PROCESS"
                                        // &&
                                        // item?.serviceTypeId?._id ===
                                        //   "632e9b76b10c8102926ba9be"
                                      ) {
                                        changeStatusToInProcessForBrokerage(
                                          item,
                                          event.target.value,
                                        );
                                      } else {
                                        checkAndChangeEnquiryStatus(
                                          item?._id,
                                          event.target.value,
                                          "",
                                          item?.serviceTypeId?._id,
                                        );
                                      }
                                    }}
                                    defaultValue={item?.status?.toUpperCase()}
                                    className='mt-1 block w-full py-1 px-3 bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs font-semibold'>
                                    <option>NEW</option>
                                    {/* <option>ASSIGNED</option> */}
                                    <option value='IN-PROCESS'>
                                      IN-PROCESS
                                    </option>
                                    <option>DROPPED</option>
                                  </select>
                                ) : (
                                  <h4 className='text-gray-dark font-bold text-sm tracking-wide pt-1 text-right overflow-hidden flex justify-end'>
                                    {/* {renderStatus(item?.status)} */}
                                    {(state.user.department?.name === "CRM" ||
                                      state.user?.aclGroup === "super-admin") &&
                                    ["NEW", "ASSIGNED", "HOLD"].includes(
                                      item?.status,
                                    ) ? (
                                      <div className='col-span-3 overflow-x-auto peer'>
                                        <p className='peer'>
                                          {renderStatus(item?.status)}
                                        </p>
                                      </div>
                                    ) : (
                                      <div className='col-span-3 overflow-x-auto overflow-y-hidden peer'>
                                        <p className='peer'>
                                          {renderStatus(item?.status)}
                                        </p>
                                      </div>
                                    )}
                                    {(state.user.department?.name === "CRM" ||
                                      state.user?.aclGroup === "super-admin") &&
                                    ["NEW", "ASSIGNED", "HOLD"].includes(
                                      item?.status,
                                    ) ? (
                                      <div
                                        className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                        onClick={(event) => {
                                          setEnquiryEditId(item?._id);
                                        }}>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          className='h-6 w-6'
                                          viewBox='0 0 20 20'
                                          fill='currentColor'>
                                          <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                        </svg>
                                      </div>
                                    ) : (
                                      <div className='ml-0 opacity-0 '></div>
                                    )}
                                  </h4>
                                )}
                              </div>
                              <div className='col-span-6 px-2 text-xs font-medium -mt-1 text-gray-200'>
                                By{" "}
                                {item.createdBy?.fullname
                                  ? item.createdBy?.fullname
                                  : item.createdBy?.firstname}
                                {item?.melaLead && "(Mela Lead)"}
                              </div>
                              <div
                                className='col-span-6'
                                onClick={(event) => {
                                  navigate(enquiryUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-0.5 text-left'>
                                  {item?.addressBookId?.prefix &&
                                  item?.addressBookId?.firstName
                                    ? item?.addressBookId?.prefix +
                                      " " +
                                      item?.addressBookId?.firstName +
                                      " " +
                                      (item?.addressBookId?.lastName
                                        ? item?.addressBookId?.lastName
                                        : "")
                                    : ""}
                                </h4>
                              </div>
                              <div
                                className='col-span-6 overflow-x-scroll'
                                onClick={(event) => {
                                  navigate(enquiryUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-0.5 text-left overflow-hidden'>
                                  {item?.serviceTypeId?.name} &gt;{" "}
                                  {item?.subServiceTypeId?.name}
                                </h4>
                              </div>
                              <div className='col-span-4'>
                                <div
                                  onClick={(event) => {
                                    navigate(enquiryUrl + "/" + item?._id, {
                                      replace: false,
                                    });
                                  }}>
                                  <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-0.5 text-left'>
                                    {item?.addressBookId
                                      ? item?.addressBookId?.crm?._id ===
                                        "636751da314cd73283ec3671"
                                        ? "+" +
                                          item?.addressBookId?.countryCode +
                                          " " +
                                          item?.addressBookId?.phoneNumber.slice(
                                            0,
                                            2,
                                          ) +
                                          "XXX XX" +
                                          item?.addressBookId?.phoneNumber.slice(
                                            7,
                                            10,
                                          )
                                        : "+" +
                                          item?.addressBookId?.countryCode +
                                          " " +
                                          item?.addressBookId?.phoneNumber
                                      : "--"}
                                    &nbsp;|&nbsp;{item?.channel}
                                  </h4>
                                </div>
                              </div>
                              {(state.user.department?.name === "CRM" ||
                                state.user?.aclGroup === "super-admin" ||
                                state.user._id === item?.createdBy) &&
                                ["NEW", "ASSIGNED", "HOLD"].includes(
                                  item?.status,
                                ) && (
                                  <div className='col-span-2 pb-2 pr-3'>
                                    <div className='grid grid-cols-2 gap-2'>
                                      <div className='z-50'>
                                        <Link to={`/enquiry/edit/${item?._id}`}>
                                          <h4 className='font-semibold text-sm text-yellow-2 text-right pr-2'>
                                            Edit
                                          </h4>
                                        </Link>
                                      </div>
                                      {(state.user.department?.name === "CRM" ||
                                        state.user?.aclGroup ===
                                          "super-admin") &&
                                        item?.status.toLowerCase() ===
                                          "new" && (
                                          <div className='z-50'>
                                            <h4
                                              onClick={() => {
                                                confirmDelete(item?._id);
                                              }}
                                              className='font-semibold text-sm text-red-600 text-right pr-2'>
                                              Delete
                                            </h4>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                        {enquiryData.length > 0 && (
                          <Pagination
                            pages={totalPages}
                            currentPage={currentPageIndex}
                            recordsPerPage={recordsPerPage}
                            changePageCallback={changePageCallback}
                            totalRecords={totalRecords}
                            changeDisplayRecordCountCallback={
                              changeDisplayRecordCountCallback
                            }
                          />
                        )}
                      </div>
                    ) : (
                      <div className='px-3 py-2'>
                        <h4 className='text-lg font-semibold'>
                          No data to display
                        </h4>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='grid grid-cols-1 gap-4 '>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Enquiry;
